document.addEventListener('DOMContentLoaded', () => {
  //add hover to desktop header drawer
  function header_drawer_hover (){
    if (!window.matchMedia('(hover: hover)').matches) return;
    const menuTrigger = document.querySelector('.header__menu-toggle');
    const drawer = document.querySelector('details-modal[open]');
  
    if (menuTrigger) {
      menuTrigger.addEventListener('mouseenter', () => {
        menuTrigger.click(); // Simulates the click to open the drawer
      });
  
      // Optional: close on mouseleave
      const menuDrawer = document.querySelector('details-modal');
      if (menuDrawer) {
        menuDrawer.addEventListener('mouseleave', () => {
          const details = menuDrawer.closest('details');
          if (details && details.hasAttribute('open')) {
            details.removeAttribute('open');
          }
        });
      }
    }
    const menuDrawerDiv = document.querySelector('#menu-drawer');
  
    if (menuDrawerDiv) {
      const summaryElements = menuDrawerDiv.querySelectorAll('summary');
      summaryElements.forEach((summary) => {
        // Hover to trigger click
        let submenu_open_btn = summary.querySelector('.svg-wrapper+.svg-wrapper');
        if(submenu_open_btn){
          submenu_open_btn.addEventListener('mouseenter', () => {
            submenu_open_btn.click();
          });
        }
        var submenu = summary.nextElementSibling;
        let submenu_close_btn = submenu.querySelector('.menu-drawer__close-button .svg-wrapper');
          if(submenu_close_btn){
            submenu_close_btn.addEventListener('mouseenter', () => {
              submenu_close_btn.click();
            });
          }
      });
    }
  }
  header_drawer_hover ();

  //back to top button 
    const backToTopButton = document.getElementById('backToTop');
    if(backToTopButton){
      function toggleBackToTop() {
        if (window.scrollY > 300) {
          backToTopButton.classList.add('show');
        } else {
          backToTopButton.classList.remove('show');
        }
      }
    
      // Check on page load
      toggleBackToTop();
    
      // Check on scroll
      window.addEventListener('scroll', toggleBackToTop);
    
      // Scroll to top on click
      backToTopButton.addEventListener('click', function() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
});